import { get, patch, post } from '../../utils/http';

export const fetchOpeningCandidates = ({ accountId, openingId }) =>
  get(`/accounts/${accountId}/ats/openings/${openingId}/candidates`);

export const addOpeningCandidate = ({ accountId, openingId, ...candidate }) =>
  post(`/accounts/${accountId}/ats/openings/${openingId}/candidates`, candidate);

// A candidate's form answers, for the candidate card's Information tab (useOpeningApplication)
export const fetchOpeningApplication = ({ accountId, openingId, applicationId }) =>
  get(`/accounts/${accountId}/ats/openings/${openingId}/applications/${applicationId}`);

// The routes below take an application id (candidate-in-this-opening), not the candidate id
export const rejectOpeningCandidate = ({ accountId, openingId, applicationId, rejectionReason }) =>
  patch(`/accounts/${accountId}/ats/openings/${openingId}/applications/${applicationId}/reject`, { rejectionReason });

export const updateOpeningCandidateStage = ({ accountId, openingId, applicationId, stageId }) =>
  patch(`/accounts/${accountId}/ats/openings/${openingId}/applications/${applicationId}/stage`, { stageId });
